import { useState } from 'react';
import { PreferenceTab } from '../../constants/preferences';

export const usePreferences = () => {
  const [activeItem, setActiveItem] = useState(PreferenceTab.PersonalInfo);

  return {
    activeItem,
    setActiveItem
  };
};
